import React, { Component, createContext, useState, ReactNode } from "react";
import ApiService, { JobEnqueueResponse } from "./api/api.service";
import BackgroundService from "./bg.service";




export default class AiService {
    private static instance: AiService;
    protected apiService: ApiService;

  
    constructor() {
        this.apiService = ApiService.getInstance();
    }

  public static getInstance(): AiService {
    if (!AiService.instance) {
        AiService.instance = new AiService();
    }

    return AiService.instance;
  }

  public async syncCompletion(prompt: string): Promise<any> {
    const response = await this.apiService.request('POST', '/completions/sync', { prompt }) as JobEnqueueResponse;

    const jobResult = await BackgroundService.getInstance().waitForJob(response.job_id);
    return jobResult;
  }

  

}